var _style, _g, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34.4 44.8",
    style: {
      enableBackground: "new 0 0 34.4 44.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#D8D8D8;}\n\t.st2{fill:#1E5096;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.2,44.3c-0.4,0-0.7-0.3-0.7-0.3l0-42.5c0-0.5,0.1-1,0.7-1h32.1c0.6,0,0.7,0.5,0.7,1V44c0,0-0.4,0.3-0.7,0.3 H1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.3,1c0.1,0,0.2,0,0.2,0.5v42.2c-0.1,0-0.1,0.1-0.2,0.1H1.2c-0.1,0-0.2,0-0.2,0V1.5C1,1,1.1,1,1.2,1H33.3  M33.3,0H1.2C0.5,0,0,0.5,0,1.5V44c0,0.3,0.5,0.8,1.2,0.8h32.1c0.6,0,1.2-0.5,1.2-0.8V1.5C34.5,0.5,34,0,33.3,0L33.3,0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.6,10.4H4.8C4.4,10.4,4,10,4,9.6s0.4-0.8,0.8-0.8h4.8c0.4,0,0.8,0.4,0.8,0.8C10.4,10,10,10.4,9.6,10.4 L9.6,10.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.4,24.8H9.6l0,0H4.8c-0.4,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h4.8l0,0h4.8c0.4,0,0.8-0.4,0.8-0.8 C15.2,25.2,14.8,24.8,14.4,24.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.6,16.8h-4.8h-2.4h-4H4.8c-0.4,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h17.6l0,0h2.4l0,0h4.8 c0.4,0,0.8-0.4,0.8-0.8C30.4,17.2,30,16.8,29.6,16.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.2,44.8h-32c-0.6,0-1.2-0.5-1.2-1.2V31.2h34.4v12.4C34.4,44.3,33.9,44.8,33.2,44.8L33.2,44.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.6,12.8h-4.8h-2.4h-4H4.8c-0.4,0-0.8,0.4-0.8,0.8c0,0.4,0.4,0.8,0.8,0.8h17.6l0,0h2.4l0,0h4.8 c0.4,0,0.8-0.4,0.8-0.8C30.4,13.2,30,12.8,29.6,12.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.6,20.8h-4.8h-2.4h-4H4.8c-0.4,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h17.6l0,0h2.4l0,0h4.8 c0.4,0,0.8-0.4,0.8-0.8C30.4,21.2,30,20.8,29.6,20.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDoc);
export default __webpack_public_path__ + "static/media/file-doc.5e0f1d41c78e36ee09f566593a27b65c.svg";
export { ForwardRef as ReactComponent };